import { lazy } from "react";
import { Navigate } from "react-router-dom";

const InventoryHosts = lazy(() => import("pages/Infrastructure/Hosts/Hosts"));
const InventoryInstances = lazy(() => import("pages/Infrastructure/Instances/Instances"));
const InventoryDatabases = lazy(() => import("pages/Infrastructure/Databases/Databases"));
const TablesOverview = lazy(() => import("pages/Infrastructure/Tables/Overview/TablesOverview"));
const TablesDetails = lazy(() => import("pages/Infrastructure/Tables/Details/TablesDetails"));
const ProcessesOverview = lazy(
  () => import("pages/Infrastructure/Processes/Overview/ProcessesOverview")
);
const ProcessDetails = lazy(() => import("pages/Infrastructure/Processes/Details/ProcessDetails"));

export const infrastructure = [
  {
    path: "infrastructure",
    element: <Navigate to="hosts" replace />,
  },
  {
    path: "infrastructure",
    children: [
      {
        path: "hosts",
        element: <InventoryHosts />,
      },
      {
        path: "instances",
        element: <InventoryInstances />,
      },
      {
        path: "databases",
        element: <InventoryDatabases />,
      },
      {
        path: "tables/overview",
        element: <TablesOverview />,
      },
      {
        path: "tables/detail",
        element: <TablesDetails />,
      },
      {
        path: "processes/overview",
        element: <ProcessesOverview />,
      },
      {
        path: "processes/detail",
        element: <ProcessDetails />,
      },
    ],
  },
];
